<template>
  <div class="header">
    <div :class="['header-container', VISIBLE.IS_AUTH ? 'w-960' : '']">
      <div class="logo">
        <img :src="logoUrl" @click="routeTo('/dashboard')" />
      </div>
      <div class="content">
        <div class="content-item" v-if="VISIBLE.LOGIN_BTN">
          <el-button type="text" @click="routeTo('/login')">{{ t('user.register.content.text_4') }}q</el-button>
        </div>
        <svg-icon :icon-class="isLocal ? '中' : '英'" @click="switchLang" class-name="icon icon-language" />
        <div class="content-item menu-light_personal" v-if="VISIBLE.PERSONAL_CENTER_BTN">
          <el-dropdown popper-class="header-dropdown-container" @visible-change="handleDropdownVisibleChange">
            <div class="user-dropdown-trigger">
              <div class="user-icon" v-if="VISIBLE.USER_NAME">
                <div class="user-avatar">{{ VISIBLE.USER_NAME.charAt(0) || '-' }}</div>
                {{ VISIBLE.USER_NAME }}
              </div>
              <div class="user-icon" v-else>
                <svg-icon icon-class="头像" class-name="icon icon-avatar" />
              </div>
              <span class="sr-name">
                <el-icon><caret-bottom /></el-icon>
              </span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <div style="padding: 10px 0;color: #999;" >
                  <div class="user-name"> {{ VISIBLE.USER_NAME }}</div>
                  {{ t('user.setting.form.text_1') }}: <span style="color: rgb(102, 102, 102);">{{ VISIBLE.USER_ID }}</span>
                </div>
                <el-dropdown-item style="margin-bottom: 10px;" v-if="agreementFile" @click="downloadAgreementInfo">
                  <div class="dropdown-item">
                    <div class="file-wrap">
                      <img :src="commercialTerms" alt="">
                      <div class="img-info-wrap">{{ agreementFileInfo }}</div>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item @click="routeTo('/user/personal')">
                  <div class="dropdown-item">
                    <svg-icon icon-class="设置" class-name="icon" />
                    {{ t('global.bindEmailDialog.content.text_6') }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-if="faceAuthStatus !== 'passed'" @click="openFaceVerification">
                  <div class="dropdown-item">
                    <svg-icon icon-class="人脸认证" class-name="icon" />
                    {{ t('settlement.faceAuthTitle') }}
                  </div>
                </el-dropdown-item>
                <!--<el-dropdown-item @click="switchLang">
                  <div class="dropdown-item">
                    <svg-icon :icon-class="isLocal?'中':'英'" class-name="icon icon-language"/>
                    {{t('global.bindEmailDialog.content.text_7')}}
                  </div>
                </el-dropdown-item>-->
                <el-dropdown-item @click="handleLogout">
                  <div class="dropdown-item" style="color: #E85F5F;">
                    <svg-icon icon-class="退出" class-name="icon" />
                    {{ t('global.bindEmailDialog.content.text_8') }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
  
  <!-- 人脸认证弹框 -->
  <face-verification-dialog
    v-model:visible="dialogVisible"
    @verify-complete="handleVerificationComplete"
  />
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { routesWhiteList } from '@/config/setting.config'
import { useI18n } from '@/plugins/i18n'
import { routeTo } from '@/utils'
import { getAgreementInfo } from '@/api/modules/auth'
import fileComp from "@/compositions/modules/file"
import { vab } from "@libs/utils"
import FaceVerificationDialog from '@/components/FaceVerificationDialog'
import { faceVerification } from '@/api/modules/settlement'

export default {
  name: 'sr-header',
  components: {
    FaceVerificationDialog
  },
  setup() {
    // todo - param
    const route = useRoute()
    const store = useStore()
    const { locale, switchLang, lang, t, isLocal } = useI18n()
    const { getFileRemoteInfo } = fileComp()

    const state = reactive({
      logoUrl: 'https://oss-img.sunrate.com/common/img/logo/logo-transparent-en.png',
      agreementFile: null,
      agreementFileInfo: t('global.content.text_15'),
      commercialTerms: require('@/assets/img/header/commercial-terms-2.png'),
      locale,
      lang,
      isLocal,
      dialogVisible: false, // 人脸认证弹框显示状态
      faceAuthStatus: 'not_passed' // 人脸认证状态
    })

    // todo - compositions
    const scopedComp = { routeTo, store }

    // todo - computed
    const scopedComputed = {
      VISIBLE: computed(() => {
        const nonBizFlag = routesWhiteList.includes(route.path) && route.path !== '/user/personal'
        return {
          LOGIN_BTN: (() => {
            return nonBizFlag && route.path !== routesWhiteList[0] && route.path !== routesWhiteList[4]
          })(),
          PERSONAL_CENTER_BTN: (() => {
            return !nonBizFlag
          })(),
          IS_AUTH: (() => {
            return route.path.includes('/auth')
          })(),
          USER_NAME: (() => {
            return store.state.user?.userInfo?.userName || ''
          })(),
          USER_ID: (() => {
            return store.state.user.userId
          })()
        }
      }),
      PATH: computed(() => {
        return {
          LANG: (() => {
            return require(`../assets/img/header/lang-${locale}.svg`)
          })()
        }
      })
    }

    // todo - methods
    const scopedMethods = {
      switchLang() {
        switchLang(locale === lang['zh-cn'] ? lang.en : lang['zh-cn'], { reload: true })
      },
      handleAcctStatus: () => {
        // console.log('handleAcctStatus')
      },
      handleLogout: async () => {
        store.dispatch('user/logout', { remote: true })
      },
      downloadAgreementInfo: async () => {
        if (!state.agreementFile) return
        try {
          const { fileName, url } = await getFileRemoteInfo(state.agreementFile)
          const link = document.createElement('a')
          link.href = url
          link.download = fileName
          link.target = '_blank'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        } catch (err) {
          console.log(`%c ${'当前输出关注'}`, 'color:#f00', err)
          vab.baseMessage('下载协议失败', 'error')
        }
      },
      fetchAgreementInfo: async () => {
        const res = await getAgreementInfo()
        if (res.agreementCheckStatus !== 'CF') return
        const { agreementFileId } = res
        state.agreementFile = agreementFileId
      },
      openFaceVerification: () => {
        state.dialogVisible = true
      },
      handleVerificationComplete: () => {
        // 处理认证完成
        state.dialogVisible = false
        vab.baseMessage('认证成功', 'success')
        // 更新人脸认证状态为通过
        state.faceAuthStatus = 'passed'
      },
      fetchFaceAuthStatus: async () => {
        try {
          const res = await faceVerification();
          state.faceAuthStatus = res.verifyResult ? 'passed' : 'not_passed';
        } catch (error) {
          console.error('获取人脸认证状态失败:', error);
          // 失败时默认设置为未通过
          state.faceAuthStatus = 'not_passed';
        }
      },
      handleDropdownVisibleChange: (visible) => {
        if (visible) {
          scopedMethods.fetchFaceAuthStatus();
        }
      }
    }

    scopedMethods.fetchAgreementInfo()
    scopedMethods.fetchFaceAuthStatus()

    return {
      ...toRefs(state),
      ...scopedComp,
      ...scopedComputed,
      ...scopedMethods,
      t,
    }
  }
}
</script>

<!--suppress CssInvalidPseudoSelector -->
<style scoped lang="scss" rel="stylesheet/scss">
$--header-height: 70px;
$--header-img-height: 25px;
$--header-logo-height: 20px;

.header {
  width: 100%;
  min-width: 1200px;
  height: $--header-height;
  line-height: $--header-height;
  background: url("../assets/img/导航bg.png") 0 0 no-repeat;
  background-size: cover;
  color: #fff;
  margin-bottom: 16px;

  .icon-language {
    color: #CDCDCD;
    font-size: 22px;
    margin: auto 20px;
    cursor: pointer;
  }

  .icon-avatar {
    font-size: 30px;
  }

  .header-container {
    display: flex;
    align-items: center;
    margin: 0 auto;
    height: $--header-height;
    padding: 0 30px;

    .logo {
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        height: $--header-logo-height;
      }
    }

    .content {
      display: flex;
      flex-grow: 1;
      justify-content: flex-end;

      .content-item {
        display: flex;
        align-items: center;
        padding-left: 20px;
        height: $--header-height;

        .lang-btn {
          height: $--header-img-height;
          cursor: pointer;
        }
      }
    }

    .sr-name {
      color: white;
      cursor: pointer;
    }

    .el-button--text {
      color: #fff;
    }
  }

  .w-960 {
    max-width: 1260px;
    padding: 0;
  }
}

.menu-light_personal {

  .user-dropdown-trigger {
    display: flex;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
  }

  .user-icon {
    color: $--color-white;
    margin-right: 6px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .user-avatar {
      width: 34px;
      height: 34px;
      background-color: #D9F5FF;
      color: #00A3DF;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 11px;
      border: 1px solid rgba(255, 255, 255, 0.43);
    }
  }

  .sr-name {
    display: flex;
    align-items: center;
  }

  &:deep(.el-menu) {
    border: none !important;
    background: $--color-primary;
  }

  &:deep(.el-submenu__title) {
    color: $--color-white !important;
    border: none !important;

    .el-submenu__icon-arrow {
      color: $--color-white !important;
    }
  }

  &:deep(.el-submenu__title:hover) {
    color: $--color-white !important;
    background: $--color-primary;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.header-dropdown-container {
  padding: 13px 30px !important;
  .user-name {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 10px;
    word-break: break-word;
  }
  
  .el-dropdown-menu__item {
    padding: 0 !important;

    .dropdown-item {
      width: 220px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      min-height: 50px;

      .file-wrap {
        position: relative;

        &>img {
          width: 100%;
          height: auto;
          display: block;
        }

        .img-info-wrap {
          /*width: 100%;*/
          position: absolute;
          top: 51%;
          left: 15px;
          transform: translateY(-50%);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, serif;
          font-weight: 400;
          color: #FFFFFF;
        }
      }

      .icon {
        font-size: 20px;
        margin-right: 19px;
      }
    }

    &:not(:last-of-type) .dropdown-item {
      border-bottom: 1px solid #F6F6F6;
    }
    & {
      &:hover {
        .dropdown-item {
          background: #C2ECFA;
        }
      }  
    }
    &:not(:last-of-type):not(:first-of-type) {
      &:hover {
        .dropdown-item {
          color: #00ACEA;
        }
      }
    }
  }
}

/* 人脸认证弹框样式 */
.face-verification {
  .verification-title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 20px;
  }
  
  .verification-method {
    margin-bottom: 25px;
    
    h4 {
      font-size: 14px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 15px;
    }
  }
  
  .qrcode-container {
    display: flex;
    justify-content: center;
  }
  
  .qrcode {
    text-align: center;
    
    .qrcode-placeholder {
      margin-bottom: 10px;
    }
    
    .qrcode-tip {
      font-size: 12px;
      color: #909399;
      margin: 0;
    }
  }
  
  .camera-tip {
    font-size: 14px;
    color: #606266;
    // margin-bottom: 15px;
  }
  
  .verification-notes {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
    
    p {
      margin: 5px 0;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
